import React from "react";
import { injectIntl, intlShape } from "react-intl";
import { Glyphicon, Media, OverlayTrigger, Tooltip } from "react-bootstrap";

class ContactsListItem extends React.Component {
  render() {
    const { contact } = this.props;

    const nameTooltip = (
      <Tooltip id={"contact-name-tooltip-" + contact.id}>
        <strong>{contact.name}</strong>
      </Tooltip>
    );

    return (
      <Media onClick={() => this.props.onClick(contact.id)}>
        <Media.Left>
          <div className="online-badge">
            <img
              width={50}
              height={50}
              className="img-circle"
              src={contact.profilePhotoUrl}
              alt="Image"
            />
            <div className={`cute-badge in-badge ${contact.online ? "on" : "off"}`} />
          </div>
        </Media.Left>
        <Media.Body>
          <div className="bold">
            <OverlayTrigger placement="top" overlay={nameTooltip}>
              <div className="media-title">{contact.name}</div>
            </OverlayTrigger>
          </div>
        </Media.Body>
      </Media>
    );
  }
}

export default injectIntl(ContactsListItem);
